import { Network } from "../../../utils/network";
import { Events } from "../../../utils/servicesEvents";
import { Formatter } from "../formatter";

async function downloadTransactions(onSuccessEvent, onErrorEvent, url) {
  const response = await sendRequest(url);
  const parsedResponse = parseResponse(response, Formatter);
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent;
  Events.dispatchEvent(onDoneEvent, parsedResponse);
}

async function sendRequest(url) {
  const userReference = await self.servicesVars.getUserReference();
  const urlToUse = url.replace(/{userId}/, userReference);

  const response = await Network.sendGetRequest(urlToUse);
  return response;
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const transactions = response.response;
    let parsedTransactions = [];
    if (Array.isArray(transactions)) {
      parsedTransactions = transactions.map(Formatter.parseExternalTransaction);
    }

    return {
      success: true,
      data: parsedTransactions,
    };
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    };
  }
  return Network.defaultResponseParsing(response);
}

export { downloadTransactions };
